import { Component, ElementRef, OnInit, ViewChild } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { CommonService } from 'src/app/services/common/common.service'
import { LoginService } from 'src/app/services/login/login.service'
@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
  @ViewChild('selectpg-popup', { static: true }) selectPgPopup: ElementRef

  selectpgPopup: any
  forgotPasswordForm: FormGroup

  constructor(
    private cs: CommonService,
    private loginService: LoginService,
    private elementRef: ElementRef,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {
    this.buildForgotPasswordForm()
    this.selectpgPopup = this.elementRef.nativeElement.querySelector('#selectpg-popup')
    this.selectpgPopup.style.display = 'block'
  }

  submit() {
    if (this.forgotPasswordForm.invalid) {
      return this.cs.showError('Invalid Employee Code')
    }
    this.loginService.dispatchForgotPasswordAction(this.forgotPasswordForm.value.employeeCode, this.exit())
  }

  exit() {
    const selectpgPopup = this.elementRef.nativeElement.querySelector('#selectpg-popup')
    return function closeModel() {
      selectpgPopup.style.display = 'none'
    }
  }

  buildForgotPasswordForm() {
    this.forgotPasswordForm = this.fb.group({
      employeeCode: ['', [Validators.required, Validators.minLength(3)]]
    })
  }

  get f() {
    return this.forgotPasswordForm?.controls
  }
}
